import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import generateEstimatePdf from "../../../../services/pdf/estimatePdfService";
import generateOrderPdf from "../../../../services/pdf/orderPdfService";
import generateSalesPdf from "../../../../services/pdf/salesPdfService";

const PdfGeneratorRoute = () => {
  const { docType, docId } = useParams();
  const [status, setStatus] = useState("Preparing your document...");
  const attemptClose = useCallback(() => {
    setTimeout(() => {
      try {
        window.close();
      } catch (err) {
        console.warn("Unable to auto-close PDF helper tab:", err);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    const generate = async () => {
      if (!docType || !docId) {
        setStatus("Missing document information.");
        return;
      }

      const type = docType.toLowerCase();

      try {
        switch (type) {
          case "estimate":
            await generateEstimatePdf(docId, { openInNewTab: true, autoPrint: true });
            break;
          case "order":
            await generateOrderPdf(docId, { openInNewTab: true, autoPrint: false });
            break;
          case "sales":
          case "invoice":
            await generateSalesPdf(docId, { openInNewTab: true, autoPrint: true });
            break;
          default:
            setStatus(`Unsupported document type: ${docType}`);
            Swal.fire("Unsupported", `No PDF generator for "${docType}"`, "info");
            return;
        }

        setStatus("PDF opened in a new tab. This tab will close automatically.");
        Swal.fire("Ready", "The PDF has opened in a new tab.", "success").finally(
          attemptClose
        );
      } catch (error) {
        console.error("PDF generation failed:", error);
        setStatus("Failed to generate PDF. Please try again.");
        Swal.fire("Error", "Failed to generate PDF. Please try again.", "error");
      }
    };

    generate();
  }, [attemptClose, docType, docId]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p style={{ fontSize: "1rem" }}>{status}</p>
    </div>
  );
};

export default PdfGeneratorRoute;

